import { useState } from 'react';
import { STORE_LINKS, detectMobilePlatform } from '@/lib/store-links';

const DISMISS_KEY = 'mustauto:app-banner-dismissed';

/**
 * Smart banner (topo, dispensável) que aparece só em celular: o web-admin é o
 * painel desktop do gestor, então no mobile vale empurrar para o app. Padrão
 * não-bloqueante (não é interstitial) — orienta sem barrar quem quer logar no
 * navegador. Reaproveita as URLs de loja já usadas pela API.
 */
export function AppDownloadBanner() {
  const [platform] = useState(detectMobilePlatform);
  const [dismissed, setDismissed] = useState(() => {
    try {
      return sessionStorage.getItem(DISMISS_KEY) === '1';
    } catch {
      return false;
    }
  });

  if (platform === 'desktop' || dismissed) return null;

  const storeUrl = platform === 'ios' ? STORE_LINKS.appStore : STORE_LINKS.googlePlay;

  function handleDismiss() {
    setDismissed(true);
    try {
      sessionStorage.setItem(DISMISS_KEY, '1');
    } catch {
      // sessionStorage indisponível (modo privado): só esconde nesta sessão.
    }
  }

  return (
    <div className="flex items-center gap-3 border-b border-border bg-card px-4 py-3 shadow-sm">
      <div className="flex h-10 w-10 flex-shrink-0 items-center justify-center rounded-lg bg-primary text-lg font-bold text-primary-foreground">
        M
      </div>
      <div className="min-w-0 flex-1">
        <p className="text-sm font-semibold text-foreground">MustAuto no celular</p>
        <p className="truncate text-xs text-muted-foreground">Gerencie sua oficina pelo app</p>
      </div>
      <a
        href={storeUrl}
        className="flex-shrink-0 rounded-lg bg-primary px-3.5 py-2 text-xs font-semibold text-primary-foreground transition-opacity hover:opacity-90"
      >
        Baixar
      </a>
      <button
        type="button"
        onClick={handleDismiss}
        aria-label="Fechar"
        className="flex-shrink-0 px-1 text-lg leading-none text-muted-foreground"
      >
        ×
      </button>
    </div>
  );
}
